import { useTranslation } from "react-i18next";
import { useGetVehicleModel } from "../../../../common/api/queries/enumerations";
import type { UUID } from "../../../../typings/global";
import { VEHICLE_OTHER_MAPPING_NAME } from "../../enums";

interface Props {
  modelId: UUID;
  otherModelName?: string;
}

export const VehicleModelEnumName = ({ modelId, otherModelName }: Props) => {
  const { t } = useTranslation();

  const { data: model, isFetched } = useGetVehicleModel(modelId);

  if (!isFetched) {
    return null;
  }

  if (!model) {
    return t("vehicle.helpers.unknownModel");
  }

  return model.name === VEHICLE_OTHER_MAPPING_NAME && otherModelName ? (
    <>{`${model.name} (${otherModelName})`}</>
  ) : (
    <>{model.name}</>
  );
};
